import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../../common/selectCustom'
import { getUnique } from '../../../../helpers/common'
import { changeSettingTable, selectDataTable } from '../store/slice'

export const CreditRiskCondition = ({ isDefaultProfile, rowId }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(selectDataTable(rowId))

  const onChooseItem = (value, conditionIndex) => {
    const arrCondition = dataRow?.conditions || []
    const newArr = [...arrCondition]
    newArr[conditionIndex] = {
      ...dataRow?.conditions?.[conditionIndex],
      conditionId: value.conditionId,
    }

    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          conditions: newArr,
        },
      }),
    )
  }

  useEffect(() => {
    if (!dataRow.conditions || !dataRow.conditions[0].conditionId) {
      dispatch(
        changeSettingTable({
          id: rowId,
          value: {
            ...dataRow,
            conditions: [
              {
                conditionId: dataRow.conditionSettings[0].conditionId,
              },
            ],
          },
        }),
      )
    }
  }, [dataRow])

  return (
    <div className="flexColumn gap1">
      {(dataRow?.conditions || [{}]).map((item, index) => (
        <ItemCondition
          key={index}
          item={item}
          index={index}
          dataRow={dataRow}
          onChooseItem={onChooseItem}
          isDefaultProfile={
            isDefaultProfile || !dataRow.sendNotification || dataRow.disabled
          }
        />
      ))}
    </div>
  )
}

export const ItemCondition = ({
  item,
  index,
  dataRow,
  onChooseItem,
  isDefaultProfile,
}) => {
  return (
    <div key={getUnique()}>
      <SelectCustom
        activeItem={{ value: item.conditionId }}
        data={dataRow.conditionSettings.map((item) => ({
          ...item,
          label: item.conditionName,
          value: item.conditionId,
        }))}
        chooseItem={(item) => onChooseItem(item, index)}
        isI18n
        disabled={!!isDefaultProfile}
        zIndex={14}
        style={{
          backgroundColor: '#D5D5D5',
          color: !!isDefaultProfile ? '#9C9C9C' : '#3A414B',
          cursor: !!isDefaultProfile ? 'not-allowed' : 'pointer',
          padding: '0px 27px 0px 12px',
          minWidth: 80,
          width: '100%',
        }}
        styleDropdown={{ whiteSpace: 'nowrap' }}
      />
    </div>
  )
}
